(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const REVEAL_CLASS = 'scroll-reveal';
  const VISIBLE_CLASS = 'scroll-reveal--visible';
  const OBSERVED_CLASS = 'scroll-reveal--observed';
  const STAGGER_MS = 130;

  const revealCard = (el, delay) => {
    window.setTimeout(() => {
      el.classList.add(VISIBLE_CLASS);
    }, delay);
  };

  const observer = new IntersectionObserver(
    (entries, obs) => {
      // Multiple cards in the same row cross the viewport threshold in the
      // same callback batch. Sort them top-to-bottom, left-to-right and
      // stagger their reveal with setTimeout so they pop up one at a time
      // instead of the whole row appearing together.
      const visible = entries.filter((entry) => entry.isIntersecting);

      visible.sort((a, b) => {
        const rectA = a.boundingClientRect;
        const rectB = b.boundingClientRect;
        if (Math.abs(rectA.top - rectB.top) > 4) return rectA.top - rectB.top;
        return rectA.left - rectB.left;
      });

      visible.forEach((entry, i) => {
        revealCard(entry.target, i * STAGGER_MS);
        obs.unobserve(entry.target);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );

  const observeCards = () => {
    const items = document.querySelectorAll('.product-grid__item:not(.' + OBSERVED_CLASS + ')');
    items.forEach((el) => {
      el.classList.add(REVEAL_CLASS, OBSERVED_CLASS);
      observer.observe(el);
    });
  };

  const init = () => {
    observeCards();

    const grid = document.querySelector('.product-grid');
    if (grid && !grid.dataset.scrollRevealWatched) {
      grid.dataset.scrollRevealWatched = 'true';
      const mutationObserver = new MutationObserver(() => observeCards());
      mutationObserver.observe(grid, { childList: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
